/**
 * Entry point for all public APIs of the package.
 */
export {TpAudioEditorModule} from './src/app/tp-audio-editor/tp-audio-editor.module';
